import React from 'react';
import classNames from 'classnames';
import {observer} from 'mobx-react';
import styles from './styles/CalendarBlock.module.scss';
import Calendar from "../../../utilities/CleverCalendar/CleverCalendar";
import {deleteContentItem} from "../Terrace";
import {useMountedEffect} from "../../../../hooks/useMountedEffect";
import ViewMoreButton from "../ViewMoreButton";
import {useStores} from "../../../../stores/useStores";
import {useGetEvents} from "../../../schoolfeed/hooks/useGetEvents";

const calendarContainerClassName = classNames({
    [styles.calendarContainer]: true,
});

const CalendarBlock = observer(props => {
    const {modalStore, organizationStore} = useStores();

    const {
        events,
        mutate,
        isLoading,
        setCurrentRange,
    } = useGetEvents(
        "eventsTerrace",
        {
            organization_id: props.blockObj.organization_id,
            organization_pk: props.blockObj.organization_id,
        }
    );

    useMountedEffect(() => {
        // update when new events are added
        mutate();
    }, [props.blockObj.content_items.length])

    const handleDelete = async (contentItem) => {
        await deleteContentItem(contentItem);
        modalStore.clearAllModals();
        mutate();
    }

    return (
        <div className={calendarContainerClassName}>

            <Calendar
                events={events || []}
                loading={isLoading}
                onRangeChange={setCurrentRange}
                aboveTheFold={props.aboveTheFold}
                expandedView={false}
                handleDeleteEvent={handleDelete}
                viewMoreButton={<ViewMoreButton text={"View More Events"}
                                                terraceType={props.blockObj.type}
                                                organizationId={organizationStore.currentOrganization.id}
                                                className={styles.viewMoreButton}/>}
            />



        </div>
    )
})

export default CalendarBlock;
